import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header5 from "../../components/header/Header5";
import Footer3 from "../../components/footer3";
import Gotop from "../../components/gotop";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons

import Breadcrumbastrologer from "../../components/breadcrumbastrologer";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import "../../assets/Spinner.css";

DashboardAstroProfile.propTypes = {};

function DashboardAstroProfile(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  
  

  const { logout } = useContext(AuthContext);

  
const [astrologerId, setAstrologerId] = useState(null);

    useEffect(() => {
      const storedUserId = localStorage.getItem("astrologerId");
      if (storedUserId) {
        setAstrologerId(storedUserId);
      }
    }, []);

  const [astroData, setAstroData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (astrologerId) {
      axios
        .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/astrologer/${astrologerId}`)
        .then((res) => setAstroData(res.data))
        .catch((err) => console.error(err));
    }
  }, [astrologerId]);

  const renderStatus = (value) => (Number(value) === 1 ? "COMPLETE" : "PENDING");

const renderButton = (value, path) => {
  const isComplete = Number(value) === 1;

  return (
    <button
      disabled={isComplete}
      onClick={() => navigate(path)}
      style={{
        backgroundColor: isComplete ? "#ccc" : "#14a077",
        color: isComplete ? "#555" : "white",
        border: "none",
        padding: "6px 12px",
        cursor: isComplete ? "not-allowed" : "pointer",
        borderRadius: "4px",
      }}
    >
      {isComplete ? "Done" : "Start"}
    </button>
  );
};
  if (!astroData) {
    return (
      <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
    <Helmet>
            <title>Registration Verification - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
        
        <Breadcrumbastrologer title="Complete Your Registration" />


        <section className="account-section">
                      <div className="tf-container">
                        <div className="row">
                          <div className="wd-form-login">
                         
                          <h5 style={{fontSize:"27px"}}>Registration Checklist</h5>
                          <p style={{marginBottom:"20px"}}>To make your profile <span style={{fontWeight:"bold"}}>PUBLIC</span>, it is important that you complete following procedures.</p>
                           
              <div style={{textAlign:"left"}}>
                <table style={{width:"100%"}}>
                <tr>
                  <td style={{width:"80%", verticalAlign:"unset"}}>
                  <p><span style={{fontWeight:"bold"}}>A. Language Preferences</span><br/>Status:  {renderStatus(astroData.Alanguages)}</p>
                  </td>
                  <td style={{width:"20%", verticalAlign:"unset"}}>
                  {renderButton(astroData.Alanguages, `/complete-language`)}
                  </td>
                  </tr>
                  <tr>
                  <td style={{width:"80%", verticalAlign:"unset"}}>
                  <p><span style={{fontWeight:"bold"}}>B. Service Preferences</span><br/>Status:  {renderStatus(astroData.Aservices)}</p>
                  </td>
                  <td style={{width:"20%", verticalAlign:"unset"}}>
                  {renderButton(astroData.Aservices, `/complete-services`)}
                  </td>
                  </tr>
                  <tr>
                  <td style={{width:"80%", verticalAlign:"unset"}}>
                  <p><span style={{fontWeight:"bold"}}>C. Profile Picture</span><br/>Status:   {renderStatus(astroData.Aphotograph)}</p>
                  </td>
                  <td style={{width:"20%", verticalAlign:"unset"}}>
                  {renderButton(astroData.Aphotograph, `/upload-photo`)}
                  </td>
                  </tr>
                  <tr>
                  <td style={{width:"80%", verticalAlign:"unset"}}>
                  <p><span style={{fontWeight:"bold"}}>D. Email Verification</span><br/>Status:     {renderStatus(astroData.Vemail)}</p>
                  </td>
                  <td style={{width:"20%", verticalAlign:"unset"}}>
                  {renderButton(astroData.Vemail, `/verify-email`)}
                  </td>
                  </tr>
                  <tr>
                  <td style={{width:"80%", verticalAlign:"unset"}}>
                  <p><span style={{fontWeight:"bold"}}>E. Phone Verification</span><br/>Status:     {renderStatus(astroData.Vnumber)}</p>
                  </td>
                  <td style={{width:"20%", verticalAlign:"unset"}}>
                  {renderButton(astroData.Vnumber, `/verify-number`)}
                  </td>
                  </tr>
                </table>
              </div>          
           <hr/>
                                <div className="group-ant-choice" style={{marginTop:"15px", textAlign:"center"}}>
                                                                                   
                                                                                    <Link to="/astrologerdashboard" className="forgot" style={{margin:"auto", fontWeight:"bold"}}>
                                                                                                                                                                   Return To Dashboard
                                                                                                                                                                 </Link>
                                                                                  </div>
                           
                          </div>
                        </div>
                      </div>
                    </section>
       
        
       
        <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:+918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
     
      <Gotop />
    </>
  );
}

export default DashboardAstroProfile;
